import React, { useEffect, useState, useRef, useCallback} from "react";
import Select from "react-select";

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { AgGridReact } from 'ag-grid-react';
import LoaderComponent from "../../../libraries/loader/loader";
import axios from 'axios';
import { fetchmailloginfo } from '../../../services/process/process_data/process_data';

import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Menu, Form, TextArea, Label } from 'semantic-ui-react';



function ReadMailInfo() {
    const [inputMonth, setInputMonth] = useState(undefined);
    const [hideResultGrid, setHideResultGrid] = useState(true);
    const [loaderOpen, setLoaderOpen] = useState(false);
    const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
    const [rowData, setRowData] = useState([]);
    const [paginationSize] = useState(15);
    const [companyname, setCompanyName] = useState({});
    const [type, setType] = useState(undefined);
    const [gridColumns, setGridColumns] = useState([]);
    const gridRef = useRef();
    const [isutr, isSetUtr] = useState(false);
    const [columnnames, setColumnNames] = useState([]);
    

     


    //  const intColumnDefs = React.useMemo(() => {
    //     if (rowData?.length > 0) {
    //       // Get the column names from the first row of the JSON data
    //       const keys = Object.keys(rowData[0]);
      
    //       // Create column definitions with the checkbox as the first column
    //       const intColumnDefs = [
            
    //         ...keys.map((key) => ({
    //           headerName: key,
    //           field: key,
    //           sortable: true, 
    //           filter: true, 
    //           resizable: true
    //         })),
    //       ];
    //       setGridColumns(intColumnDefs);
    //       console.log('intColumnDefs', intColumnDefs);
    //       return intColumnDefs;
    //     }
    //     return [];
    //   }, [rowData]);


    var advice_columns = [
        { field: 'ALCS letter', headerName: 'ALCS letter', sortable: true, filter: true, resizable: true },
        { field: 'Bank', headerName: 'Bank', sortable: true, filter: true, resizable: true },
        { field: 'Chq,Ref.No', headerName: 'Chq Ref.No', sortable: true, filter: true, resizable: true },
        { field: 'Date', headerName: 'Date', sortable: true, filter: true, resizable: true }
    ]
 

    
    const fetchreadmailinfo = () => {

        let payload = {
            File_data: 'test',
          }
      
          var FileUploadCredentials = fetchmailloginfo();
      
          axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
            .then(
              response => {
                console.log("Validate Credentials Response!!!", response);
                let data = response.data;
                   // Transform the data into rows suitable for AgGridReact
                const rowData1 = data.from_mail.string.map((email, index) => ({
                    fromMail: email,
                    subject: data.subject.string[index],
                    date: data.subject.date[index],
                    body: data.body.string[index],
                    mailId: data.from_mail.mail_id[index],
                    domainName: data.from_mail.domain_name[index],
                    id: index + 1, // Add unique ID if needed
                }));
                setRowData(rowData1)
              }
            ).catch(
              error => {
                console.log("Error", error);
                alert("Error in Save file!!!");
              }
            );
    }

 

  // Column definitions for AgGridReact
  const columnDefs = [
    { headerName: 'From Mail', field: 'fromMail' },
    { headerName: 'Subject', field: 'subject' },
    { headerName: 'Date', field: 'date' },
    { headerName: 'Body', field: 'body' },
    { headerName: 'Mail ID', field: 'mailId' },
    { headerName: 'Domain Name', field: 'domainName' },
    // Add more columns as needed
  ];

  
    // useEffect(() => {
    //     fetchreadmailinfo(); 
    // },[]);

    const searchForm = () =>{
      fetchreadmailinfo(); 
    }


    return (
        <>
            <div className="file-upload-cardBox">
                <div className="file-upload-card">
                    <div>
                        <label htmlFor="underline_select " className="numbers" style={{fontSize: '15px'}}>File Type</label><br />
                        <div className="cardName">
                            <div className="dropdown-container">
                                <Select id="file-upload-select"
                                
                                placeholder="Select Type"
                                style={{width:'9em'}}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="file-upload-card">
                    <div>
                        <label  id="underline_select" htmlFor="underline_select " className=" numbers" style={{fontSize: '15px'}}>Date</label><br />
                        <input type="month" name="month" value='' className="cardName filetype" style={{paddingLeft: "10px"}} id="file-upload-month" />
                      
                    </div>
                </div>

                <div className="file-upload-card">
                    <div>
                        <label htmlFor="underline_select " className="numbers " style={{fontSize: '15px'}}>File Upload</label><br />
                        <form  id="file-upload-form">
                            <input type="file"  />
                            <input type="submit" value="Upload" className="btn" style={{height:"35px",marginTop: "-60px",marginLeft:"330px",backgroundColor:"#000055",color:"#ffffff"}} />
                        </form>
                              
                    </div>
                    
                </div>
                <div className="file-upload-card">
                    <button style={{height:"35px",marginTop: "2em",marginLeft:"61px",backgroundColor:"#000055",color:"#ffffff", width:"7%", borderRadius:"9%"}} onClick={searchForm}>
                        Read Mail
                    </button>
                </div>
            </div>
            
            <div className="report" >
                
                <div className="ag-theme-balham report-layer" style={{width:'100%', heidght:'100%'}}>
                    <AgGridReact
                        columnDefs={columnDefs}
                        rowData={rowData}
                        paginationPageSize={15}
                        pagination={true}
                        animateRows={true}
                        rowSelection={'multiple'}
                        groupSelectsChildren={true}
                        // ref={gridRef}
                        suppressAggAtRootLevel={true}
                        suppressRowClickSelection={true}
                        
                    >
                    </AgGridReact>
                </div>
            </div>
          
            <LoaderComponent loaderOpen={loaderOpen} />

        </>
    )
}

export default ReadMailInfo;










